<template>
  <v-container class="pt-0">
    <div class="container ma-0 pa-0 mb-1">
      <h4 class="mb-2 ml-3">{{title}}</h4>
      <a :href="link">
        <img class="mb-3" :src="image" />
      </a>
      <v-btn class="button ma-0 pa-2 mb-1" :href="link" color="info">
          <!-- <v-icon class="icon">shopping_cart</v-icon> -->
          <div class="shop">More info</div>
        </v-btn>

    </div>
    </v-container>
</template> 

<script>
export default {
  name: "Chapter",
  data: () => ({}),
  props: {
    image: String,
    link: String,
    title: String
  }
};
</script>

<style scoped>
img{
  box-shadow: 1px 5px 7px 1px black;
  max-width: 60%;
  margin:auto;
  display:block;
}

.container{
  max-width: 250px;
  min-width: 150px;
  width: 5%;
  display: inline-block;
}

.shop{
  font-size: 12px;
}

.button{
  width:70%;
  margin:auto !important;
  display: block;
}

>>> .v-btn__content{
  width:90% !important;
  margin: auto;
}

.shop{
  font-weight: bold;
}

</style>